import { render, staticRenderFns } from "./FaqsetSkeleton.vue?vue&type=template&id=63a0f46c&"
import script from "./FaqsetSkeleton.vue?vue&type=script&lang=js&"
export * from "./FaqsetSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports